import { render } from "./IntroduceTable.vue?vue&type=template&id=538e48ee&scoped=true&ts=true"
import script from "./IntroduceTable.vue?vue&type=script&lang=ts"
export * from "./IntroduceTable.vue?vue&type=script&lang=ts"

import "./IntroduceTable.vue?vue&type=style&index=0&id=538e48ee&lang=less&scoped=true"

import exportComponent from "/Users/jiangshanwen/workspace/website-3.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-538e48ee"]])

export default __exports__